import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, map, Observable, Subscription } from 'rxjs';
import { CompanySummary } from 'src/app/models/generic-models/views/CompanySummary';
import { CookiePromptComponent } from './cookie-prompt/cookie-prompt.component';

const COOKIE_CONSENT_STRING = 'cookie-consent';
const COOKIE_ACCEPT_STRING = 'accept';
const COOKIE_REFUSE_STRING = 'refuse';

@Injectable({
  providedIn: 'root',
})
export class CookieAcceptService {
  private _subs: Subscription[] = [];
  private _dialogRef?: MatDialogRef<CookiePromptComponent>;

  private _companySummary: BehaviorSubject<CompanySummary | undefined> = new BehaviorSubject<
    CompanySummary | undefined
  >(undefined);

  public companySummary$: Observable<CompanySummary | undefined> = this._companySummary.asObservable();
  public companySlug$: Observable<string | undefined> = this._companySummary.asObservable().pipe(
    map((company) => {
      return company?.slug;
    }),
  );

  constructor(
    private dialogService: MatDialog,
    private router: Router,
    private cookieService: CookieService,
  ) {
    //if (environment.addScriptsOnStart) this.cookiePrompt();
  }

  public initCookies() {
    if (this.cookieService.check(COOKIE_CONSENT_STRING)) {
      const consent = this.cookieService.get(COOKIE_CONSENT_STRING);
      if (consent === COOKIE_ACCEPT_STRING) {
        this._addScripts();
        return;
      }
      return;
    }
    if (this._dialogRef) {
      this._dialogRef.close();
    }
    if (!this.cookieService.check(COOKIE_CONSENT_STRING)) {
      this.cookiePrompt();
    }
  }

  public setCompanySummary(company: CompanySummary) {
    this._companySummary.next(company);
  }

  cookiePrompt() {
    this._dialogRef = this.dialogService.open(CookiePromptComponent, {
      disableClose: false,
      hasBackdrop: false,
      position: { bottom: '0px' },
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      minHeight: '0px',
    });

    this._subs.push(
      this._dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.cookieService.set(COOKIE_CONSENT_STRING, COOKIE_ACCEPT_STRING);
          this._addScripts();
        }
        if (result === false) {
          this.cookieService.set(COOKIE_CONSENT_STRING, COOKIE_REFUSE_STRING);
        }
      }),
    );
  }

  private _addScripts() {
    /* if (!environment.production) {
      return;
    } */

    // Add GTM script

    const gtmScript = document.createElement('script');
    gtmScript.type = 'text/javascript';
    gtmScript.async = true;
    gtmScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-F2Y092LYYW';
    document.head.appendChild(gtmScript);

    const gaScript = document.createElement('script');
    gaScript.type = 'text/javascript';
    gaScript.textContent = `
          window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-F2Y092LYYW');
        `;

    document.head.appendChild(gaScript);
    // Default: deny everything (runs BEFORE loading gtag.js)
    (window as any).gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'granted',
    });
    (window as any).gtag('consent', 'update', { analytics_storage: 'granted' });

    // Add Clarity script
    const clarityScript = document.createElement('script');
    clarityScript.type = 'text/javascript';
    clarityScript.textContent = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "oxh0n9kb9b");
    `;
    document.head.appendChild(clarityScript);
    (window as any).clarity?.('consentv2', {
      ad_Storage: 'denied',
      analytics_Storage: 'granted',
    });
  }

  public dispose() {
    for (const sub of this._subs) {
      sub.unsubscribe();
    }
  }
}
